import { API_BASE_URL } from '../config/api';

export const authService = {
  async login(name, password) {
    try {
      const payload = { name, password };
      const response = await fetch(`${API_BASE_URL}/api/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      const data = await response.json();
      if (!response.ok) {
        return { success: false, message: data.message || data.error || 'Erreur de connexion' };
      }
      return data;
    } catch (error) {
      console.error('Login error:', error);
      throw error;
    }
  },

  async verifyToken(token) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/verify`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const result = await response.json();
        return result.data?.user || null;
      }
      return null;
    } catch (error) {
      console.error('Token verification error:', error);
      return null;
    }
  },

  async resetPassword(email) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/reset-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();
      return {
        success: response.ok && data.success !== false,
        message: data.data?.message || data.message || data.error,
        code: data.code,
        status: response.status,
      };
    } catch (error) {
      console.error('Reset password error:', error);
      throw error;
    }
  },

  async validateResetToken(token) {
    try {
      const response = await fetch(
        `${API_BASE_URL}/api/auth/validate-reset-token?token=${encodeURIComponent(token)}`
      );
      return response.ok;
    } catch {
      return false;
    }
  },

  async confirmResetPassword(token, newPassword) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/confirm-reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ token, newPassword }),
      });
      const data = await response.json();
      return {
        success: data.success,
        message: data.data?.message || data.message,
      };
    } catch (error) {
      console.error('Confirm reset password error:', error);
      throw error;
    }
  },

  async updatePassword(userId, oldPassword, newPassword, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/update-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ userId, oldPassword, newPassword }),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || data.error || 'Erreur lors du changement de mot de passe');
      }
      
      return data;
    } catch (error) {
      console.error('Update password error:', error);
      throw error;
    }
  },

  async updateProfile(profileData, token) {
    try {
      const response = await fetch(`${API_BASE_URL}/api/auth/update-profile`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify(profileData),
      });

      const data = await response.json();
      
      if (!response.ok) {
        throw new Error(data.message || data.error || 'Erreur lors de la mise à jour du profil');
      }
      
      return data;
    } catch (error) {
      console.error('Update profile error:', error);
      throw error;
    }
  },
};

